export function defaultWidgetLabelProvider(widgetType) {
    switch (widgetType) {
        case 'form.altcha':
            return 'ALTCHA';
        case 'form.colorGradientPicker':
            return 'Color Gradient';
        case 'form.colorPicker':
            return 'Color';
        case 'form.iconPicker':
            return 'Icon';
        case 'form.dateTimePicker':
            return 'Date-Time';
        case 'form.dateTimeRangePicker':
            return 'Date-Time Range';
        case 'form.googleReCaptchaV2':
            return 'Google reCAPTCHA';
        case 'form.subForm':
            return 'Sub-Form';
        case 'formUs.ssn':
            return 'SSN';
    }
    const label = widgetType.replace(/\w+\./, '').replace(/([A-Z])/g, ' $1');
    return label.substring(0, 1).toUpperCase() + label.substring(1);
}
